import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box, Heading } from 'roo-ui/components';
import Summary from './components/Summary';

export const SearchResultSummary = ({ resultCount, totalPropertyCount, location, isLoading }) => {
  const titleText = isLoading || resultCount > 0 ? `Hotels in ${location}` : `We couldn't find any hotels matching your search`;
  return (
    <Fragment>
      <Box display={['none', 'block']} minHeight="80px" my={8}>
        <Heading.h1 data-testid="location-header">{titleText}</Heading.h1>
        <Summary isLoading={isLoading} resultCount={resultCount} totalPropertyCount={totalPropertyCount} />
      </Box>
    </Fragment>
  );
};

SearchResultSummary.propTypes = {
  isLoading: PropTypes.bool,
  location: PropTypes.string,
  resultCount: PropTypes.number,
  totalPropertyCount: PropTypes.number,
};

SearchResultSummary.defaultProps = {
  isLoading: false,
  location: '',
  resultCount: 0,
  totalPropertyCount: 0,
};
